import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminLayoutComponent } from './admin-layout.component';
import { MenuComponent } from './components/menu/menu.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { LogoComponent } from './components/logo/logo.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { RouterModule } from '@angular/router';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MenuModule } from 'primeng/menu';
import { BadgeModule } from 'primeng/badge';
import { SpinnerModule } from '../../components/spinner/spinner.module';
import { NotificacaoBadgeComponent } from '../../components/notificacao-badge/notificacao-badge.component';
import { EnvironmentBadgeComponent } from '../../components/environment-banner/environment-banner.component';

@NgModule({
  declarations: [
    AdminLayoutComponent,
    MenuComponent,
    TopbarComponent,
    LogoComponent,
    BreadcrumbComponent,
    UserMenuComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    BreadcrumbModule,
    MenuModule,
    BadgeModule,
    SpinnerModule,
    NotificacaoBadgeComponent,
    EnvironmentBadgeComponent,
  ],
  exports: [AdminLayoutComponent],
})
export class AdminModule {}
